import React, { useEffect, useState } from "react"
import { Redirect, withRouter } from "react-router-dom"
import { useSelector } from "react-redux"
import { loginEmail } from "#/redux/reducers/loginInfo"
import { Link } from "@carrotfertility/carotene-core"
import { carrotClient } from "#/utils/CarrotClient"
import RequestResetPassword from "#/pages/request-reset-password"
import { FormattedMessage } from "react-intl"
import { EmployeeSupportUrl } from "../../../utils/EmployeeSupportLink"

const UnknownError = (): JSX.Element => {
  return (
    <>
      <FormattedMessage
        defaultMessage="Oops, something went wrong. Please try again later or <link>contact us</link> for assistance."
        values={{
          link: (linkContent) => (
            <Link color="error" href={EmployeeSupportUrl} target={"_blank"}>
              {linkContent}
            </Link>
          )
        }}
      />
    </>
  )
}

const RequestResetPasswordContainer = (): JSX.Element => {
  const [errorMessage, setErrorMessage] = useState(null)
  const [loading, setLoading] = useState(false)
  const email = useSelector(loginEmail)

  useEffect(() => {
    const resetPassword = async () => {
      if (!email) {
        return
      }

      try {
        setLoading(true)
        await carrotClient.forgotPassword(email)
        setLoading(false)
      } catch {
        // Uniform 204 means nothing here is account-state-specific; the backend reports its own failures, so just
        // show a generic message.
        setErrorMessage(<UnknownError />)
        setLoading(false)
        return
      }
    }

    resetPassword()
  }, [email])

  return email ? <RequestResetPassword {...{ loading, errorMessage }} /> : <Redirect to="/" />
}

export default withRouter(RequestResetPasswordContainer)
